import { RegisterForm } from "@/components/register-form"
import { Helmet } from "react-helmet-async"

export default function RegisterPage() {
  return (
    <>
      <Helmet>
        <title>Sign Up for Fusegu | Start Free Security Scan</title>
        <meta 
          name="description" 
          content="Create your account and run your first comprehensive security scan free. 7-day free trial with 3 scans per day. No credit card required." 
        />
        <meta property="og:title" content="Sign Up for Fusegu - Free Security Scanning" />
        <meta property="og:description" content="Start your free trial today. Run comprehensive security scans with 10+ professional tools." />
        <meta property="og:url" content="https://fusegusecurity.com/register" />
      </Helmet>
      <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
        <div className="w-full max-w-sm">
          <h1 className="sr-only">Sign Up for Fusegu Security - Start Free Trial</h1>
          <RegisterForm />
        </div>
      </div>
    </>
  )
}